/*!
 *
 *	input-instagram.js
 *
 */

var defo = {
	cl: 'tp-Instagram_Item',
	count: 5
};


$.fn.inputInstagram = function(options){

	var $wrapper = this;

	var setting = $.extend({}, defo, options);

	var token = '7061835314.c5d3621.1cdcee7c1bd74900a24aef6fbd2e5995';
	var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + token;

	var buildData = function(data){
		var $elem = '';
		var _limit = setting.count;
		if( _limit > data.length ){
			_limit = data.length;
		};
		for( var i=0; i<_limit; i++){
			$elem += '<div class="'+ setting.cl +'"><a href="'+ data[i].link +'" target="_blank"><img src="'+ data[i].images.standard_resolution.url +'" alt=""></a></div>'
		};
		$wrapper.append($elem);
	};

	$.ajax({
		url: url,
		dataType: 'json'
	}).done(function(data){
		//console.log( data.data );
		buildData(data.data);
	}).fail(function(a){
		console.log(a)
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/input-instagram.js
// module id = 19
// module chunks = 0